import { GetStaticProps } from 'next'
import { NextSeo } from 'next-seo'

import { AdditionalPageNav } from 'sections/common/additional-page-nav'
import { AboutUsPage, strapi } from 'api'
import { REVALIDATION_TIMEOUT } from 'const/config'
import { LearnMore, MainContent } from 'sections/about'
import { FaqSection } from 'components/faqs'
import { TeamMemberAvatarProps } from 'components/team-members/team-member-avatar'

interface AboutUsProps {
  pageInfo: AboutUsPage
  teamMembersAvatars: TeamMemberAvatarProps['person'][]
}

export default function AboutUs({ pageInfo, teamMembersAvatars }: AboutUsProps) {
  const { main_content_title, main_content, faqs, welcome_title, welcome_content } = pageInfo

  return (
    <>
      <NextSeo title="About Us" />
      <AdditionalPageNav
        page="aboutUs"
        welcomeContent={welcome_content}
        welcomeContentTitle={welcome_title}
      />
      <MainContent title={main_content_title} content={main_content} />
      <LearnMore peopleAvatars={teamMembersAvatars} />
      <FaqSection items={faqs} title="Common questions about REZITRADE" />
    </>
  )
}

export const getStaticProps: GetStaticProps<AboutUsProps> = async () => {
  const pageData = await strapi.pages.aboutUs()
  const teams = await strapi.teams.find({
    fields: ['full_name'],
    pagination: {
      limit: 6,
    },
  })
  return {
    revalidate: REVALIDATION_TIMEOUT,
    props: {
      pageInfo: pageData,
      teamMembersAvatars: teams.items,
    },
  }
}
